import React, { FC, useEffect } from 'react';

import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRefinementList } from 'react-instantsearch';

import { DEFAULT_DISCOVER_URL } from '../../../../const';
import CategoryNavigationLink from '../CategoryNavigationLink';

interface ExpertNavigationBlockProps {
  attribute: string;
  initialExpert?: string;
}

const ExpertNavigationBlock: FC<ExpertNavigationBlockProps> = ({ attribute, initialExpert }) => {
  const { t } = useTranslation();

  const { refine } = useRefinementList({ attribute });

  useEffect(() => {
    if (refine && initialExpert) {
      refine(initialExpert);
    }
  }, [refine, initialExpert]);

  return (
    <Box>
      <CategoryNavigationLink to={`${DEFAULT_DISCOVER_URL}/experts`}>
        {t('page.discover.backToExperts')}
      </CategoryNavigationLink>
    </Box>
  );
};

export default ExpertNavigationBlock;
